const isDev = process.env.NODE_ENV === 'development';
const BASE = isDev ? '' : (process.env.REACT_APP_API_BASE_URL || '');
const SETTINGS_ENDPOINT = BASE ? `${BASE.replace(/\/$/, '')}/api/settings` : '/api/settings';

function getBasicAuthHeader() {
    const user = process.env.REACT_APP_API_USER ||
        (typeof window !== 'undefined' && window.localStorage.getItem('REACT_APP_API_USER'));
    const pass = process.env.REACT_APP_API_PASSWORD ||
        (typeof window !== 'undefined' && window.localStorage.getItem('REACT_APP_API_PASSWORD'));

    if (user && pass) {
        let encoded;
        if (typeof window !== 'undefined' && window.btoa) {
            encoded = window.btoa(`${user}:${pass}`);
        } else if (typeof Buffer !== 'undefined') {
            encoded = Buffer.from(`${user}:${pass}`).toString('base64');
        }
        return `Basic ${encoded}`;
    }
    return undefined;
}

const getHeaders = () => {
    const headers = { 'Content-Type': 'application/json' };
    const auth = getBasicAuthHeader();
    if (auth) headers['Authorization'] = auth;
    return headers;
};

export async function getSettings() {
    const res = await fetch(SETTINGS_ENDPOINT, { headers: getHeaders() });
    if (!res.ok) throw new Error(`Request failed with status ${res.status}`);
    return await res.json();
}

export async function updateSettings(settings) {
    const res = await fetch(SETTINGS_ENDPOINT, {
        method: 'PUT',
        headers: getHeaders(),
        body: JSON.stringify(settings)
    });
    if (!res.ok) throw new Error(`Failed to update settings: ${res.status}`);
    return true;
}
